import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as scActions from '../../actions/serviceCatalog';
import ServiceCatalogC from '../../constants/serviceCatalog';
import ScView from './scView';
import ScBreadcrumbs from './scBreadcrumbs';
import Style from './style.scss';
import { Col, Grid, Row } from 'react-bootstrap';
import styled from 'styled-components';
import intlC from '../../constants/intl';
import * as analyticActions from '../../actions/analytics';
import Breadcrumbs from '../Breadcrumbs';
import Cx from 'classnames';
import C from '../../constants/serviceCatalog';

const StyledWrapper = styled.div`
  border: solid 1px ${props => props.theme.borderColor};
`;

export class ServiceCatalog extends React.Component {
  constructor() {
    super();
  }

 

  addBranch(branch) {
    //for FOLDER
    if(branch.type === 'FOLDER'){
      this.props.serviceCatalogActions.getToolboxItemsByParentID(branch,false);
      return;
    }  
    //for ref pointer
    if(branch && Number.isInteger(branch)){
      this.props.serviceCatalogActions.getToolboxItemsByRef(branch);
    }else{
      //for catogory pointer
      this.props.serviceCatalogActions.addBranchToCurrentBranches(branch);
    }
  }

  removeBranch(branch) {
    
    if(branch.id == 1){
      this.props.serviceCatalogActions.getFunctionalitiesMetaDataArray(0,true);
    }else{
      if(branch.type === 'CATEGORY_INFO' || branch.type === 'CATEGORY_POINTER'){
        this.props.serviceCatalogActions.removeBranchFromCurrentBranches(branch);
      }else{
        this.props.serviceCatalogActions.getToolboxItemsByParentID(branch,true);
      }
    } 
  }

 

  getCurrentTree(currentServiceCatalogItems, currentBranch) {
      
     if(currentBranch.length === 0){
       return currentServiceCatalogItems[0];
     }

    
     let count =0;
     if(currentServiceCatalogItems[0].children.length > 0){
       for(let i=0; i<currentServiceCatalogItems[0].children.length;++i){
          if(currentServiceCatalogItems[0].children[i].type === C.SUBMIT_INCIDENT || currentServiceCatalogItems[0].children[i].type ===C.SUBMIT_REQUEST){
            count++;
          }
       }
     }

     if(count == currentServiceCatalogItems[0].children.length){
      return currentServiceCatalogItems[0];
     }
     
     const clickedBranch  = currentBranch[currentBranch.length -1];
     const currentServiceCatalogItemsChildren = currentServiceCatalogItems[0].children;

     if(clickedBranch.id == 1){
        return  currentServiceCatalogItems[0]; 
     }
     if(clickedBranch.type !== 'CATEGORY_INFO'){
      for(let i =0; i < currentServiceCatalogItemsChildren.length; ++i){
          const serviceCatalogItem  = currentServiceCatalogItemsChildren[i];
          if(serviceCatalogItem.id === clickedBranch.id){
            return serviceCatalogItem;
          }
        }
    }

      if(clickedBranch.type === 'CATEGORY_INFO'){
        for(let i =0; i < currentServiceCatalogItemsChildren.length; ++i){
          const serviceCatalogItem  = currentServiceCatalogItemsChildren[i];
          if(this.isItemPartOfBranch(serviceCatalogItem,currentBranch)){
            const currentTree  = this.findCurrentTree(clickedBranch,serviceCatalogItem,currentBranch);
            if(currentTree !== null){
              return currentTree;
            }
         }
        }
      }
      

      return currentServiceCatalogItems[0];
  }

  findCurrentTree(clickedBranch,serviceCatalogItem,currentBranch){
    let startIndex = this.findStartOfCategoryInfo(currentBranch);
    if(currentBranch[startIndex].id === serviceCatalogItem.id){
      startIndex = startIndex +1;
    }
    const currentTree  = this.getCurrentTreeRecursion(serviceCatalogItem,clickedBranch,currentBranch, startIndex);
    if(currentTree !== null){
      return currentTree;
    }
  }

  getCurrentTreeRecursion(serviceCatalogItem,clickedBranch,currentBranch,index){
    if(serviceCatalogItem === null || serviceCatalogItem === undefined ){
      return null;
    }

    if(serviceCatalogItem.id === clickedBranch.id && serviceCatalogItem.type === clickedBranch.type && index === currentBranch.length){
      return serviceCatalogItem;
    }

    const targetID = currentBranch[index].id;
    for(let i=0; i< serviceCatalogItem.children.length; ++i){
      if(serviceCatalogItem.children[i].id === targetID){
        const currentTree = this.getCurrentTreeRecursion(serviceCatalogItem.children[i],clickedBranch,currentBranch,index +1);
        if(currentTree !== null){
          return currentTree;
        }
      }
    }
    return null;
  }

  findStartOfCategoryInfo(currentBranch){
     for(let i=0; i<currentBranch.length;++i){
       if(currentBranch[i].type === 'CATEGORY_INFO'){
         return i;
       }
     }
     return 1;
  }

  findBranchOfAnItem(currentServiceCatalogItems,currentItem,branch,initialItemId) {
    let childItem;
    for (let j = 0; j < currentServiceCatalogItems.length; j++) {
      childItem = currentServiceCatalogItems[j];
      if (childItem.id == initialItemId) {
        return [currentItem, childItem];
      } else if (childItem.type === 'FOLDER' && childItem.children.length > 0) {
        branch = this.findBranchOfAnItem(
          childItem.children,
          childItem,
          branch,
          initialItemId
        );
        if (branch.length > 0) {
          branch = [currentItem, ...branch];
          break;
        }
      }
    }
    return branch;
  }

  isItemPartOfBranch(serviceCatalogItem, currentBranch){
    for(let i= 0; i< currentBranch.length; ++i){
      if(currentBranch[i].id === serviceCatalogItem.id && currentBranch[i].type === serviceCatalogItem.type && currentBranch[i].Name === serviceCatalogItem.Name){
        return true;
      }
    }
    return false;
  }

  componentDidMount() {
    if(this.props.location !== undefined){
      const location = this.props.location;
      let type = undefined;
      if(location.pathname.includes(C.FOLDER)){
        type = C.FOLDER
      }else if(location.pathname.includes(C.CATEGORY_POINTER)){
        type = C.CATEGORY_POINTER;
      }
      if(type !== undefined){
        const index = location.pathname.indexOf(type);
        const id = location.pathname.substring(index+ type.length +1).trim();
        if(type === C.FOLDER){
          let branch = {};
          branch.id = id;
          this.props.serviceCatalogActions.getToolboxItemsByParentID(branch,true);
        }else if(type === C.CATEGORY_POINTER){
          this.props.serviceCatalogActions.getToolboxItemsByRef(id,true);
        }else{
          this.props.serviceCatalogActions.getFunctionalitiesMetaDataArray(0, true);
        }
      }
    }else{
      this.props.serviceCatalogActions.getFunctionalitiesMetaDataArray(0, true);
    }
  }

  componentWillReceiveProps(nextProps) {
    const branches =
        [
          {
            type: 'FOLDER',
            id: 1,
            name: 'Home',
            description: 'Home description'
          }
        ];

    if (this.props.serviceCatalogItems != nextProps.serviceCatalogItems && nextProps.match &&nextProps.match.params.id) {
      let initialBranch = this.findBranchOfAnItem(
        nextProps.serviceCatalogItems[0].children,
          this.props.currentBranches ? this.props.currentBranches.slice() : branches.slice(),
        [],
        nextProps.match.params.id
      );
      this.setState({ currentBranches: initialBranch });
    }
  }

  render() {

    const branches = 
    [
      {
        type: 'FOLDER',
        id: 1,
        name: 'Home',
        description: 'Home description'
      }
    ];



    const currentTree = this.getCurrentTree(this.props.serviceCatalogItems,
                                            this.props.currentBranches ? this.props.currentBranches.slice() : branches.slice());
    let breadcrumbs,
      scViewLgCols = 12,
      scViewLgOffset = 0;
    //change component's design when it's not in widget-mode in the home-page
    if (this.props.match && this.props.match.params.id) {
      breadcrumbs = <Breadcrumbs />;
      scViewLgCols = 10;
      scViewLgOffset = 1;
    }
    let isContainFolders = false;
    for (let i = 0; i < this.props.serviceCatalogItems.length; i++) {
        for (let j = 0; j < this.props.serviceCatalogItems[i].children.length; j++) {
            if(this.props.serviceCatalogItems[i].children[j].type === 'FOLDER' || this.props.serviceCatalogItems[i].children[j].type === 'CATEGORY_POINTER'){
                isContainFolders = true;
            }
        }
    }

    


    return (
      <Grid fluid>
        {breadcrumbs}
        <Row>
          <Col
            lg={scViewLgCols}
            lgOffset={scViewLgOffset}
            md={12}
            className="noSidePadding">
            <StyledWrapper className= {Cx(isContainFolders ? '' : Style.autoHeight, Style.scWrapper, 'sspScWrapper')}>
              <ScBreadcrumbs
                intlObject={this.props.intlObject}
                currentBranches={ this.props.currentBranches || branches }
                updateBranch={this.removeBranch.bind(this)}
                reportAnalytics={this.props.analyticActions.reportAnalytics}
              />
              <ScView
                {...currentTree}
                intlObject={this.props.intlObject}
                updateBranch={this.addBranch.bind(this)}
                reportAnalytics={this.props.analyticActions.reportAnalytics}
              />
            </StyledWrapper>
          </Col>
        </Row>
      </Grid>
    );
  }
}

ServiceCatalog.propTypes = {
  serviceCatalogItems: PropTypes.array.isRequired,
  serviceCatalogActions: PropTypes.object.isRequired,
  analyticActions: PropTypes.object.isRequired,
  intlObject: PropTypes.object.isRequired,
  match: PropTypes.object,
  currentBranches: PropTypes.object,
  location:PropTypes.object
};

function mapDispatchToProps(dispatch) {
  return {
    serviceCatalogActions: bindActionCreators(scActions, dispatch),
    analyticActions: bindActionCreators(analyticActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    serviceCatalogItems: state.serviceCatalog.get(ServiceCatalogC.CATALOG_ITEMS),
     intlObject: state.intl.get(intlC.INTL_OBJECT),
     currentBranches: state.serviceCatalog.get(ServiceCatalogC.CURRENT_BRANCHES)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceCatalog);



// WEBPACK FOOTER //
// ./components/ServiceCatalog/index.js